export default function templatesFakeApi(server, apiPrefix) {
  server.get(`${apiPrefix}/templates`, (schema) => {
    return schema.db.templates;
  });

  server.get(`${apiPrefix}/input-types`, () => {
    return [];
  });
}
